module.exports = __webpack_public_path__ + "img/logo.41d0c34e.png";